import { Injectable } from '@angular/core';
import { LogsPerHourStat } from '../models/chart-data';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ReportDataService {

  constructor(private http: HttpClient) { }

  getErrorsLast48Hours(){
    return this.http.get<LogsPerHourStat[]>(environment.baseURl + `/api/values/errors`)
  }

}
